<template>
  <nav class="nav-main" :class="[ isSticky ? 'sticky-top' : 'remove-sticky-top']">
    <vueper-slides
      ref="vueperslides"
      class="no-shadow nav-list"
      :visible-slides="arrMenu.length"
      :arrows="false"
      :bullets="false"
      :bullets-outside="false"
      :dragging-distance="50"
      fixed-height="48px"
      transition-speed="300"
      @slide="slideChange"
    >
      <vueper-slide
        class="nav-item"
        :key="item.name"
        v-for="(item, index) in arrMenu"
        @click.native="slideClick(index)"
        :class="[ currentRouteName == item.route_name ? 'active' :'' ]"
        :data-tab="getDataTab(item)"
        data-action="open_tab"
      >
        <template v-slot:content>
          <div class="vueperslide__content-wrapper">
            <div class="vueperslide__title">{{item.name}}</div>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </nav>
</template>
<script>
import { VueperSlides, VueperSlide } from "vueperslides"
import "vueperslides/dist/vueperslides.css"

import { mapActions } from "vuex"
export default {
  components: {
    VueperSlides,
    VueperSlide
  },
  props: {
    arrMenu: {
      type: Array,
      default: []
    },
    pathLevel: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      isSticky: false
    }
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        if (this.$route.query.activeMenu) {
          let index = this.arrMenu.findIndex(i => i.route_name == this.$route.query.activeMenu)
          setTimeout(() => {
            this.$refs.vueperslides && this.$refs.vueperslides.goToSlide(index)
          }, 100)
        }
      })
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.matched[this.pathLevel] ? this.$route.matched[this.pathLevel].name : null
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll)
  },
  mounted() {
    if (this.$route.name == "miniapp-market") this.$refs.vueperslides.goToSlide(1)
    else {
      let routeName, index
      this.$route.matched.length < 4 ? (routeName = this.$route.name) : (routeName = this.$route.matched[2].name)
      index = this.arrMenu.findIndex(item => (item.route_name == routeName))
      this.$refs.vueperslides.goToSlide(index)
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    ...mapActions("global", ["saveMarketActiveTab"]),
    slideClick(index) {
      this.$refs.vueperslides && this.$refs.vueperslides.goToSlide(index)
    },
    slideChange(e) {
      this.redirectLink(this.arrMenu[e.currentSlide.index])
    },
    async redirectLink(obj) {
      if (obj.route_scroll >= 0) {
        window.scrollTo(0, obj.route_scroll)
      }

      if (obj.route_replace) {
        this.$router.replace(obj.route_obj)
      } else {
        this.$router.push(obj.route_obj)
      }

      if (obj.remember_router) {
        await this.saveMarketActiveTab(obj.route_name)
      }
    },
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      currentScrollPosition > 0 ? (this.isSticky = true) : (this.isSticky = false)
    },
    getDataTab({ name }) {
      switch (name) {
        case "OVERVIEW":
          return "fund_overview"
        case "RETURN":
          return "fund_performance"
        case "PORT":
          return "fund_portfolio"
        case "FEES":
          return "fund_fee"
        case "FUNDS":
          return "market_fund"
        case "STOCKS":
          return "market_stock"
        case "LOTTO":
          return "market_lotto"
        case "INDICES":
          return "market_index"
        case "GOLD":
          return "market_gold"
        case "CRYPTO":
          return "market_crypto"
        default:
          return ""
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-main {
  position: fixed;
  top: 0;
  width: 100%;
  background: $color-white;
  border-bottom: 1px solid $color-border;
  z-index: 11;
  .nav-list {
    list-style: none;
    .nav-item {
      @include finRippleBtn($color-white, $color-white, $color-light-grey-2);
      display: block;
      color: $color-secondary-text;
      @extend %font-size-s;
    }
    .active {
      position: relative;
      color: $color-normal-text;
      font-weight: bold;
      &:after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        -webkit-animation: widthAnimate 0.3s; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: widthAnimate 0.3s; /* Firefox < 16 */
        -ms-animation: widthAnimate 0.3s; /* Internet Explorer */
        -o-animation: widthAnimate 0.3s; /* Opera < 12.1 */
        animation: widthAnimate 0.3s;
        background-color: $color-orange-finno;
        height: 4px;
      }
    }
  }
}

.sticky-top {
  position: sticky;
  top: 0;
}
.remove-sticky-top {
  position: relative;
}
@keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Firefox < 16 */
@-moz-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Internet Explorer */
@-ms-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Opera < 12.1 */
@-o-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>